module.exports = "<!--the headlines in policy manager page-->\n<div class=\"policyEngineMenu\" >\n    <div class=\"header\">\n        <div class=\"text\" *ngFor=\"let title of titles; let i = index\"\n            [ngClass]=\"{ 'selected': i == $state.params.index }\"\n            (click)=\"$state.go(title.state)\">\n            {{title.name}}\n        </div>\n    </div>\n    <hr>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/policyEngine/policy-engine-menu/policy-engine-menu.component.html
// module id = 1766
// module chunks = 0